<template>
    <app-main>
        <app-content>

            <!-- Start Title -->
            <app-title
                title="Media"
            />
            <!-- End Title -->

            <app-box>
                <app-filemanager />
            </app-box>

        </app-content>
    </app-main>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import FileManager from '@/components/filemanager/Filemanager';

    export default {
        name: 'media.home',

        data: () => ({

        }),
        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-filemanager': FileManager
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/media/Home.vue